import React from 'react';
import DecisionTree from './components/DecisionTree';
export function App() {
  return <div className="w-full h-screen bg-gray-50" data-id="element-0">
      <DecisionTree data-id="element-1" />
    </div>;
}